import { useEffect, useState } from "react";
import { Typography, FormHelperText, Grid } from "@mui/material";
import { tss } from "tss-react";
import EventsEmitter from "events/EventsEmitter";

var useStyles = tss.create({
    statsTopPanel: {
        backgroundColor: "transparent",
        position: "absolute",
        width: 1200,
        right: 10,
        bottom: 10,
    },
    statsLabel: {
        textAlign: "right",
        marginTop: -5,
        color: "#F2613D",
        margin: 0,
        padding: 0,
    },
    statsValue: {
        textAlign: "right",
        color: "white",
        fontSize: 18,
        margin: 0,
        padding: 0,
    },
});

const formatStat = (x: number) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default function StatsPanel(props: { show: boolean }) {
    const { classes } = useStyles();
    const { show } = props;
    const [statsEntry, setStatsEntry] = useState<any>(null);
    useEffect(() => {
        var updateStats = (newStats: any) => {
            const newStatsEntry = newStats.length > 0 ? newStats[newStats.length - 1] : null;
            setStatsEntry({ ...newStatsEntry });
        };
        EventsEmitter.on("update_stats", updateStats);
        return () => {
            EventsEmitter.removeEventListener("update_stats", updateStats);
        };
    }, []);
    return (
        <div className={classes.statsTopPanel}>
            {statsEntry !== null && show ? (
                <div
                    style={{
                        position: "absolute",
                        width: 1200,
                        right: 10,
                        bottom: 10,
                        backgroundColor: "rgba(0, 0, 0, 0.50)",
                    }}
                >
                    <Grid container direction="row">
                        <Grid xs={1} item></Grid>
                        <Grid xs={1} item></Grid>
                        {statsEntry["timestamp_data_request"] ? (
                            <Grid xs={1} item>
                                <Typography className={classes.statsValue}>
                                    {formatStat(
                                        statsEntry["timestamp_data_request"].low -
                                            statsEntry["timestamp_request_received"].low
                                    )}
                                    <span style={{ fontSize: 12 }}> ms</span>
                                </Typography>
                                <FormHelperText className={classes.statsLabel}>Request</FormHelperText>
                            </Grid>
                        ) : (
                            <Grid xs={1} item></Grid>
                        )}
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(statsEntry["db_time"] - statsEntry["download_data_parallel_time"].low)}
                                <span style={{ fontSize: 12 }}> ms</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Read Stall</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(statsEntry["content_service_time"])}
                                <span style={{ fontSize: 12 }}> ms</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Server Work</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(statsEntry["download_data_parallel_time"].low)}
                                <span style={{ fontSize: 12 }}> ms</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>DB Read</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(
                                    Math.round(
                                        (1000 * statsEntry["download_data_size"].low) /
                                            (1024 * 1024 * statsEntry["download_data_parallel_time"].low)
                                    )
                                )}
                                <span style={{ fontSize: 12 }}> MB/s</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>DB Bandwidth</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(
                                    Math.round(
                                        statsEntry["download_data_serial_time"].low /
                                            statsEntry["download_data_parallel_time"].low
                                    )
                                )}
                                <span style={{ fontSize: 12 }}> times</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Parallelization</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(Math.round(statsEntry["download_data_size"].low / 1024))}
                                <span style={{ fontSize: 12 }}> KB</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Server Data</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(Math.round(statsEntry["data_size"] / 1024))}
                                <span style={{ fontSize: 12 }}> KB</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Client Data</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(statsEntry["network_time"])}
                                <span style={{ fontSize: 12 }}> ms</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Network</FormHelperText>
                        </Grid>
                        <Grid xs={1} item>
                            <Typography className={classes.statsValue}>
                                {formatStat(Math.round(statsEntry["throughput"] / 1024))}
                                <span style={{ fontSize: 12 }}> KB/s</span>
                            </Typography>
                            <FormHelperText className={classes.statsLabel}>Throughput</FormHelperText>
                        </Grid>
                    </Grid>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
